const getCommonTrackingParams = props => ({
  appName: 'Acorns',
  screen: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  ...props,
});

export const EVENT_ACTIONS = {
  CANCEL: 'Cancel',
  CLEAR: 'Clear',
  CLOSE: 'Close',
  COPY: 'Copy',
  CREATE: 'Create',
  DELETE: 'Delete',
  DOWNLOAD: 'Download',
  DROP: 'Drop',
  EDIT: 'Edit',
  IDENTIFY: 'Identify',
  IMPORT: 'Import',
  LOAD: 'Load',
  NAVIGATE_TO: 'Navigate to',
  OPEN: 'Open',
  REFRESH: 'Refresh',
  SAVE: 'Save',
  SET: 'Set',
  START: 'Start',
  TOGGLE: 'Toggle',
  ZOOM_TO: 'Zoom to',
};

export const pageEvent = (props = {}) => {
  window.analytics.page('Acorns Page', getCommonTrackingParams(props));
};

export const trackEvent = (eventName, props = {}) => {
  window.analytics.track(
    `[acorns] ${eventName}`,
    getCommonTrackingParams(props),
  );
};

export const identify = user => {
  const identifyOptions = {
    Intercom: {
      hideDefaultLauncher: true,
    },
  };

  window.analytics.identify(
    user.user_id,
    {
      email: user.email,
      userId: user.user_id,
      organizationId: user.organization_id,
      programId: user.program_id,
      roleLevel: user.role_level,
      workspaceId: user.pl_workspace,
      projectId: user.pl_project,
      sh_user_id: user.sh_user_id,
      name: user.name,
      firstName: user.first_name,
      lastName: user.last_name,
    },
    identifyOptions,
    () => {
      trackEvent('App - Identify User', {
        appSection: 'App',
        action: EVENT_ACTIONS.IDENTIFY,
        target: 'User',
      });
    },
  );
};

export const reset = () => analytics.reset();
